import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { completeFeedback, feedbackQueryKeys } from '../api/feedback.api';
import type { CompleteFeedbackPayload } from '../types/feedback.types';

interface CompleteArgs {
  id: number;
  payload: CompleteFeedbackPayload;
}

export function useCompleteFeedback(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: CompleteArgs) => completeFeedback(id, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: feedbackQueryKeys.all() });
      toast.success('Feedback completed');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to complete feedback');
    },
  });
}
